import axios from 'axios';
const BASE = 'https://fitnesstrac-kr.herokuapp.com/api';
// import getCurrentUser from '../auth/index'

export default async function PostRoutine({ creatorId, isPublic, routineName, goalName, token, user }){
    
    const body = {
        creatorId : creatorId,
        name: routineName,
        goal: goalName,
        isPublic: isPublic
    }

    const headers = { 'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`}
    try {
      const response = await axios.post(`${BASE}/routines`, body, {headers : headers})
      const {data} = response
      
      return data
      
      
    } catch (error) {
      console.error(error);
    } 
}